import type {
  AuthResponse,
  LoginRequest,
  RegisterRequest,
} from '../types/user';
import { api, writeTokens } from './api';

export async function login(body: LoginRequest): Promise<AuthResponse> {
  const { data } = await api.post<AuthResponse>('/auth/login', body);
  return data;
}

export async function register(body: RegisterRequest): Promise<AuthResponse> {
  const { data } = await api.post<AuthResponse>('/auth/register', body);
  return data;
}

export function persistAuth(auth: AuthResponse): void {
  writeTokens(auth.accessToken, auth.refreshToken);
}

export function clearAuth(): void {
  writeTokens(null, null);
}

export async function forgotPassword(email: string): Promise<void> {
  await api.post('/auth/forgot-password', { email }, { skipAuth: true } as any);
}

export async function resetPassword(token: string, newPassword: string): Promise<void> {
  await api.post('/auth/reset-password', { token, newPassword }, { skipAuth: true } as any);
}

export async function verifyEmail(token: string): Promise<void> {
  await api.post('/auth/verify-email', { token }, { skipAuth: true } as any);
}

export async function resendVerification(email: string): Promise<void> {
  await api.post(`/auth/resend-verification?email=${encodeURIComponent(email)}`, {}, { skipAuth: true } as any);
}
